import {
	GetUserLibraryDocument,
	GetUserLibraryQuery,
	GetUserLibraryQueryVariables,
} from '@/features/jwtv-titles-rental/graphql/queries/GetUserLibrary.query';
import { useQuery } from '@/helpers/composables/useApollo';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { rentalListLocales } from '@/routing/lists';

import { computed } from 'vue';

export function useUserRentals() {
	const { country, language, webLocale } = useLanguageStore();
	const { isLoggedIn } = useUserStore();

	const isUserLibraryEnabled = computed(() => {
		return isLoggedIn.value && rentalListLocales.includes(webLocale.value);
	});

	const { result, loading } = useQuery<GetUserLibraryQuery, GetUserLibraryQueryVariables>(
		GetUserLibraryDocument,
		() => ({
			country: country.value,
			language: language.value,
		}),
		{ fetchPolicy: 'network-only', enabled: isUserLibraryEnabled }
	);

	const allUserRentals = computed(() => {
		return result.value?.getUserLibrary?.items.filter(el => el.node) || [];
	});

	const activeUserRentals = computed(() => {
		return allUserRentals.value.filter(el => el.expiry && new Date(el.expiry) >= new Date());
	});

	const pastUserRentals = computed(() => {
		return allUserRentals.value.filter(el => el.expiry && new Date(el.expiry) < new Date());
	});

	return {
		allUserRentals,
		activeUserRentals,
		pastUserRentals,
		loading,
	};
}
